// extracted by mini-css-extract-plugin
export default {"search":"src-components-Base-Search-search--YCbP2","searchPane":"src-components-Base-Search-searchPane--JVhua","searchBtn":"src-components-Base-Search-searchBtn--QjMv9"};